var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgnitionOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5423 17.415C21.7217 17.0816 24.1998 14.3926 24.1998 11.1248C24.1998 7.62129 21.3783 4.79977 17.8748 4.7998C14.3816 4.79984 11.5498 7.63161 11.5498 11.1248C11.5498 11.4441 11.5735 11.7578 11.6193 12.0643L18.5423 17.415ZM16.1821 17.9167L15.8322 18.3103C15.7512 18.4014 15.652 18.4742 15.5408 18.5241C15.4297 18.574 15.3093 18.5998 15.1875 18.5998H13.8498V20.0373C13.8498 20.5137 13.4637 20.8998 12.9873 20.8998H11.5498V22.3373C11.5498 22.8137 11.1637 23.1998 10.6873 23.1998H6.6623C6.18595 23.1998 5.7998 22.8137 5.7998 22.3373V19.5321C5.7998 19.3033 5.89069 19.0839 6.05241 18.9222L11.0356 13.939L16.1821 17.9167ZM19.5998 11.1248C18.6471 11.1248 17.8748 10.3525 17.8748 9.39981C17.8748 8.4471 18.6471 7.6748 19.5998 7.6748C20.5525 7.6748 21.3248 8.4471 21.3248 9.39981C21.3248 10.3525 20.5525 11.1248 19.5998 11.1248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8926 21.0233L5.97737 7.94964C5.77698 7.79382 5.74075 7.50487 5.89658 7.3042L6.46124 6.57768C6.61706 6.377 6.90629 6.34077 7.10697 6.49689L24.0222 19.5705C24.2226 19.7264 24.2589 20.0153 24.103 20.216L23.5384 20.9425C23.3825 21.1432 23.0933 21.1791 22.8926 21.0233Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnitionOff);
export default __webpack_public_path__ + "static/media/ignition_off.8777ec98b20604107fc21bc8f59a426a.svg";
export { ForwardRef as ReactComponent };